import { Link } from 'react-router-dom';
import { useTranslation } from '../i18n';
import EternoLogo from '/assets/Eterno_logo.webp';

export default function Footer() {
  const { t } = useTranslation();
  
  return (
    <footer className="bg-transparent mt-16">
      {/* Social Media Section */}
      <section className="py-12 px-4 sm:px-6 lg:px-8">
        <div className="max-w-7xl mx-auto">
          <div className="bg-white rounded-2xl shadow-xl p-8 hover:shadow-2xl transition-all duration-300 border border-green-100">
            <div className="flex flex-col items-center space-y-6 text-center sm:text-left">
              <h3 className="text-h3 text-gray-800">Follow Us</h3>
              <div className="flex space-x-8">
                <a 
                  href="https://www.instagram.com/p/DUiG77CCUB_/?igsh=bzhzMXp1aHg3NGQ2"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="text-gray-600 hover:text-health-primary transition-colors"
                  aria-label="Instagram"
                >
                  <svg className="w-8 h-8" fill="currentColor" viewBox="0 0 24 24">
                    <path d="M12 2.163c3.204 0 3.584.012 4.85.07 3.252.148 4.771 1.691 4.919 4.919.058 1.265.069 1.645.069 4.849 0 3.205-.012 3.584-.069 4.849-.149 3.225-1.664 4.771-4.919 4.919-1.266.058-1.644.07-4.85.07-3.204 0-3.584-.012-4.849-.07-3.26-.149-4.771-1.699-4.919-4.92-.058-1.265-.07-1.644-.07-4.849 0-3.204.013-3.583.07-4.849.149-3.227 1.664-4.771 4.919-4.919 1.266-.057 1.645-.069 4.849-.069zm0-2.163c-3.259 0-3.667.014-4.947.072-4.358.2-6.78 2.618-6.98 6.98-.059 1.281-.073 1.689-.073 4.948 0 3.259.014 3.668.072 4.948.2 4.358 2.618 6.78 6.98 6.98 1.281.058 1.689.072 4.948.072 3.259 0 3.668-.014 4.948-.072 4.354-.2 6.782-2.618 6.979-6.98.059-1.28.073-1.689.073-4.948 0-3.259-.014-3.667-.072-4.947-.196-4.354-2.617-6.78-6.979-6.98-1.281-.059-1.69-.073-4.949-.073zM5.838 12a6.162 6.162 0 1112.324 0 6.162 6.162 0 01-12.324 0zM12 16a4 4 0 110-8 4 4 0 010 8zm4.965-10.405a1.44 1.44 0 112.881.001 1.44 1.44 0 01-2.881-.001z"/>
                  </svg>
                </a>
                <a 
                  href="https://www.facebook.com/share/1CGSKeBMvC/?mibextid=wwXIfr"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="text-gray-600 hover:text-blue-600 transition-colors"
                  aria-label="Facebook"
                >
                  <svg className="w-8 h-8" fill="currentColor" viewBox="0 0 24 24">
                    <path d="M24 12.073c0-6.627-5.373-12-12-12s-12 5.373-12 12c0 5.99 4.388 10.954 10.125 11.854v-8.385H7.078v-3.47h3.047V9.43c0-3.007 1.792-4.669 4.533-4.669 1.312 0 2.686.235 2.686.235v2.953H15.83c-1.491 0-1.956.925-1.956 1.874v2.25h3.328l-.532 3.47h-2.796v8.385C19.612 23.027 24 18.062 24 12.073z"/>
                  </svg>
                </a>
                <a 
                  href="https://www.linkedin.com/posts/eterno-fit_eterno-comingsoon-holistichealthcare-activity-7426564228024635392-dFFy?utm_source=share&utm_medium=member_ios&rcm=ACoAAASkJlcBs4U58MIUNikJTX4VYG9aNVRDz04"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="text-gray-600 hover:text-blue-700 transition-colors"
                  aria-label="LinkedIn"
                >
                  <svg className="w-8 h-8" fill="currentColor" viewBox="0 0 24 24">
                    <path d="M20.447 20.452h-3.554v-5.569c0-1.328-.027-3.037-1.852-3.037-1.853 0-2.136 1.445-2.136 2.939v5.667H9.351V9h3.414v1.561h.046c.477-.9 1.637-1.85 3.37-1.85 3.601 0 4.267 2.37 4.267 5.455v6.286zM5.337 7.433c-1.144 0-2.063-.926-2.063-2.065 0-1.138.92-2.063 2.063-2.063 1.14 0 2.064.925 2.064 2.063 0 1.139-.925 2.065-2.064 2.065zm1.782 13.019H3.555V9h3.564v11.452zM22.225 0H1.771C.792 0 0 .774 0 1.729v20.542C0 23.227.792 24 1.771 24h20.451C23.2 24 24 23.227 24 22.271V1.729C24 .774 23.2 0 22.222 0h.003z"/>
                  </svg>
                </a>
                <a 
                  href="https://www.youtube.com/@eterno-fit"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="text-gray-600 hover:text-red-600 transition-colors"
                  aria-label="YouTube"
                >
                  <svg className="w-8 h-8" fill="currentColor" viewBox="0 0 24 24">
                    <path d="M23.498 6.186a3.016 3.016 0 0 0-2.122-2.136C19.505 3.545 12 3.545 12 3.545s-7.505 0-9.377.505A3.017 3.017 0 0 0 .502 6.186C0 8.07 0 12 0 12s0 3.93.502 5.814a3.016 3.016 0 0 0 2.122 2.136c1.871.505 9.376.505 9.376.505s7.505 0 9.377-.505a3.015 3.015 0 0 0 2.122-2.136C24 15.93 24 12 24 12s0-3.93-.502-5.814zM9.545 15.568V8.432L15.818 12l-6.273 3.568z"/>
                  </svg>
                </a>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Main Footer Section */}
      <section className="px-4 sm:px-6 lg:px-8 py-8">
        <div className="max-w-7xl mx-auto">
          <div className="bg-white rounded-2xl shadow-xl p-8 hover:shadow-2xl transition-all duration-300 border border-purple-100">
            <div className="flex flex-col md:flex-row gap-8 md:gap-12 justify-center items-center md:justify-between md:items-start">
              <div className="flex flex-col items-center md:items-start">
                <Link className="flex items-center mb-4" to="/">
                  <img src={EternoLogo} alt="Eterno" className="h-32 w-auto" />
                </Link>
              </div>
              <div className="flex gap-8 md:gap-12 justify-center">
                <div className="flex flex-col items-center sm:items-start text-center">
                  <Link className="text-base font-semibold text-gray-800 mb-4 hover:text-purple-600 transition-colors" to="/">Company</Link>
                  <Link className="text-sm text-gray-600 mb-2 hover:text-purple-600 transition-colors" to="/about">About Us</Link>
                  <Link className="text-sm text-gray-600 mb-2 hover:text-purple-600 transition-colors" to="/contact">Contact Us</Link>
                  <Link className="text-sm text-gray-600 mb-2 hover:text-purple-600 transition-colors" to="/refund-and-cancellation">Cancellation and Refund Policy</Link>
                  <Link className="text-sm text-gray-600 mb-2 hover:text-purple-600 transition-colors" to="/shipping-and-delivery">Shipping and Delivery Policy</Link>
                  <Link className="text-sm text-gray-600 mb-2 hover:text-purple-600 transition-colors" to="/terms-and-conditions">Terms and Conditions</Link>
                  <Link className="text-sm text-gray-600 mb-2 hover:text-purple-600 transition-colors" to="/privacy-policy">Privacy Policy</Link>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>


      {/* Copyright Section */}
      <section className="px-4 sm:px-6 lg:px-8 py-6">
        <div className="max-w-7xl mx-auto">
          <div className="bg-white rounded-2xl shadow-xl p-6 hover:shadow-2xl transition-all duration-300 border border-purple-100">
            <div className="text-center">
              <span className="text-sm text-gray-600">© 2025 Svasam Veda Lifesciences Pvt Ltd. All rights reserved</span>
            </div>
          </div>
        </div>
      </section>
    </footer>
  );
}
